import { HttpStatusCodes } from '@service-initiation/shared-clients-http';
import { logger } from '@service-initiation/shared-clients-osp-logger';
import { queryClient } from '@service-initiation/shared-utils-query-client';

import { techCareServicesClient } from './clients/techCareServicesClient';

export const cancelAppointment = async (
  leadId: number
): Promise<{ status: number }> => {
  try {
    const cancelAppointmentRes = await queryClient.fetchQuery({
      queryFn: async () => {
        const response = await techCareServicesClient.cancelAppointment(leadId);

        if (response.status === HttpStatusCodes.InternalServerError) {
          const err = new Error(
            'Internal Server error occurred while trying to cancel appointment.'
          );
          logger.error(err, {
            data: {
              response: {
                data: response.body,
                status: response.status,
              },
            },
          });
          throw err;
        }

        return response.status;
      },
      queryKey: ['cancelAppointment', leadId],
      retry: 2,
      staleTime: Infinity,
    });

    return {
      status: cancelAppointmentRes,
    };
  } catch (e) {
    const err = e as Error;
    err.message = 'Error occurred while trying to cancel appointment lead.';
    logger.error(err, {
      data: { leadId },
    });
    throw err;
  }
};
